import { NewBaseService } from "./newBase.service";
export { NewBaseService } from "./newBase.service";

import { UserService } from "./UserService";
export { UserService } from "./UserService";

export const sharedServices = [UserService, NewBaseService];
